import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { WEB_COMPONENT_GLOBAL_EXCLUSIONS, WEB_COMPONENT_EXCLUSION_LISTS, WEB_COMPONENT_NEW_EXCLUSION_LIST } from '../../../webcomponents.constants';
import { ExclusionListItem } from '../../exclusionsPanel/types';
import { ServerResponseKind } from '../../../types/common/types';
import { GlobalExclusionsWebComponent } from '../../exclusionsPanel';
import { ExclusionListsWebComponent } from '../../exclusionsLists';
import { NewExclusionListWebComponent } from '../../exclusionListItemsEditPanel';
import { translateFn } from '../../../utils/translator.helper';

export class GlobalExclusionsAppView extends BaseWebComponentView {

  public dom: {
    $wrapper: HTMLElement;
    $newExclusionList: NewExclusionListWebComponent;
    $globalExclusions: GlobalExclusionsWebComponent;
    $exclusionsLists: ExclusionListsWebComponent;
    $title: HTMLElement;
    $titleLink: HTMLElement;
    $allListsTitle: HTMLElement;
    $listTitle: HTMLElement;
  };

  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$newExclusionList = this.shadow.querySelector(WEB_COMPONENT_NEW_EXCLUSION_LIST);
    this.dom.$globalExclusions = this.shadow.querySelector(WEB_COMPONENT_GLOBAL_EXCLUSIONS);
    this.dom.$exclusionsLists = this.shadow.querySelector(WEB_COMPONENT_EXCLUSION_LISTS);
    this.dom.$title = this.shadow.querySelector('.title');
    this.dom.$titleLink = this.shadow.querySelector('.title-link');
    this.dom.$allListsTitle = this.shadow.getElementById('allListsTitle');
    this.dom.$listTitle = this.shadow.getElementById('listTitle');
    this.injectDependenciesInChildren();
  }

  buildView(data: any) {
    if (data.kind === ServerResponseKind.SUCCESS && data.response) {
      this.buildExclusionLists(data.response?.userLists, data.response?.companyLists, data.response?.activeExclusionList);
      this.buildNewExclusionListForm();
      this.buildGlobalExclusionsGrid(data);
    } else {
      this.buildErrorView();
    }
  }

  buildExclusionLists(userLists: ExclusionListItem[], companyLists: ExclusionListItem[], activeListItem) {
    this.dom.$listTitle.innerHTML = translateFn('Exclusions lists').toUpperCase();
    this.dom.$exclusionsLists.userExclusionLists = userLists ?? [];
    this.dom.$exclusionsLists.companyExclusionLists = companyLists ?? [];
    this.dom.$exclusionsLists.newListString = translateFn('New list');
    this.dom.$exclusionsLists.allExclusionsString = translateFn('All exclusions');
    this.dom.$exclusionsLists.userExclusionListsTitle = translateFn('My lists');
    this.dom.$exclusionsLists.companyExclusionListsTitle = translateFn('Other lists');
    this.dom.$exclusionsLists.setActiveListItem(!activeListItem.value ? null : activeListItem);
  }

  private buildGlobalExclusionsGrid(data) {
    if (data.response.activeExclusionList.value !== undefined) {
      this.dom.$globalExclusions.activeExclusionList = data.response?.activeExclusionList;
    }
  }

  buildNewExclusionListForm() {
    this.dom.$newExclusionList.isVisible = false;
  }

  buildErrorView() {
    this.dom.$wrapper.innerHTML = 'no data';
  }

  showNewExclusionListForm() {
    this.dom.$newExclusionList.isVisible = true;
    this.dom.$newExclusionList.listId = '';
  }

  private injectDependenciesInChildren() {
    if (this.dom.$globalExclusions.injectDependencies) {
      this.dom.$globalExclusions.injectDependencies(this.dependencies);
      this.dom.$globalExclusions.start().catch(console.error);
    }

    if (this.dom.$newExclusionList.injectDependencies) {
      this.dom.$newExclusionList.injectDependencies(this.dependencies);
      this.dom.$newExclusionList.start().catch(console.error);
    }
  }

  refreshGrid(listId: any, showFirstPage: boolean) {
    const globalExclusion = this.dom.$globalExclusions;
    const gridView = globalExclusion.controller?.view.dom.$gridView;

    // set extra params
    gridView.extraParams = {
      companyId: Application.Main.getActiveCompany().id,
      listId: listId,
    };

    // reload grid
    showFirstPage ? gridView.controller.loadFirstPage() : gridView.controller.handleGridItemsLoad();
  }
}
